import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/guards/auth';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  providers: [AuthenticationService]
})
export class SidebarComponent implements OnInit {
  menus: any[] = [];
  user: any = {};
  menugrupo: any = [];
  token: any;
  pathAvatar: string = 'assets/img/profile.png';

  constructor(public _as: AuthenticationService) {
    if (window.location.pathname != '/login') {
      this.token = this._as.getToken();
      if ((this.token != null) && (localStorage.getItem('u') != null)) {
        this.user = JSON.parse(localStorage.getItem('u'));       
        this.getMenu();
      }
    }
  }

  ngOnInit() {
  }

  getMenu() {
    if (this.user.vistas != null) {
      this.menugrupo = this.user.vistas;
      this.crearMenu(this.menugrupo);
    }
  }

  crearMenu(resp) {

    var menuFinal = [];
    var menuMaster = [];
    var menuHijos = [];
    menuMaster = resp;
    menuHijos = resp.vistas;
    for (let i in menuMaster) {
      var item = menuMaster[i];
      var lsMenuHijo = [];
      menuHijos = item.vistas;
      for (let j in menuHijos) {
        var itemHijo = menuHijos[j];
        var objHijo = {
          titulo: itemHijo.titulo,
          url: itemHijo.uri,
          icon: itemHijo.icono
        };

        lsMenuHijo.push(objHijo);
      }

      var obj = {
        titulo: item.modulo,
        icon: item.icono,
        submenu: lsMenuHijo

      };
      menuFinal.push(obj);

    }
    this.menus = menuFinal;
  }


}
